import { render, staticRenderFns } from "./BcbPartnerList.vue?vue&type=template&id=b6d9b6f2&scoped=true"
import script from "./BcbPartnerList.vue?vue&type=script&lang=js"
export * from "./BcbPartnerList.vue?vue&type=script&lang=js"
import style0 from "./BcbPartnerList.vue?vue&type=style&index=0&id=b6d9b6f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d9b6f2",
  null
  
)

export default component.exports